import React, { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { Circle, ExpandMore } from '@mui/icons-material';
import {
    Popover,
    Box,
    Typography,
    Stack,
    Collapse
} from '@mui/material';
import { LegendIconButton } from '../style/map_components';

const MapShelterAnalysisLegendIcon = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [legendOpen, setLegendOpen] = useState(false);
    const [shelterOpen, setShelterOpen] = useState(false);
    const [evacAreaOpen, setEvacAreaOpen] = useState(false);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        console.log('handleClose')
        setAnchorEl(null);
    };

    // アイコンのスタイル
    const iconStyle = { width: '21px', height: '21px' }

    const shelterItems = [
        { color: '#ffaa67', label: '3日以上報告がない避難所' },
        { color: '#d134d0', label: '急激な避難者数増減がある避難所' },
        { color: '#a49f9e', label: '閉鎖した避難所' },
        { color: '#98cdec', label: '過去3日間で開設した避難所' },
        { color: '#3391d5', label: '開設している避難所' },
        { color: '#e5f1fa', label: '過去3日間に閉鎖した避難所' }
    ];

    const evacAreaItems = [
        { color: '#0c000c', label: '緊急安全確保' },
        { color: '#b92ec9', label: '避難指示' },
        { color: '#ff2600', label: '高齢者等避難' },
        { color: '#faf600', label: '注意報' },
        { color: '#ededed', label: '早期注意報' },
        { color: '#bfbfbf', label: '発令なし' }
    ];

    const ExpandableHeader = ({ label, expanded, toggle, sx = {} }) => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                mb: 0.5,
                ...sx,
            }}
            onClick={toggle}
        >
            <ExpandMore
                sx={{
                    transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
                    transition: 'transform 0.2s',
                    fontSize: 16,
                    mr: 0.5
                }}
            />
            <Typography sx={{ fontSize: '0.75rem' }}>{label}</Typography>
        </Box>
    );

    return (
        <>
            <LegendIconButton
                onClick={handleClick}>
                <InfoIcon sx={iconStyle} />
            </LegendIconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ p: 1, maxHeight: 200, overflowY: 'auto' }}>
                    {/* タイトル部：クリックで開閉 */}
                    <ExpandableHeader
                        label="凡例"
                        expanded={legendOpen}
                        toggle={() => setLegendOpen(!legendOpen)}
                    />
                    <Collapse in={legendOpen}>
                        <Box sx={{ pl: 2 }}>
                            {/* サブセクション1 */}
                            <ExpandableHeader
                                label="避難所"
                                expanded={shelterOpen}
                                toggle={() => setShelterOpen(!shelterOpen)}
                                sx={{ mb: 0.25 }}
                            />
                            <Collapse in={shelterOpen}>
                                <Stack direction="column" spacing={0.5} pl={1}>
                                    {shelterItems.map((item, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Circle sx={{ color: item.color, fontSize: "10px" }} />
                                            <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 60 }}>{item.label}</Typography>
                                            <Typography sx={{ fontSize: "10px", pl: 1, ml: '30px' }}>{item.threshold}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Collapse>
                        </Box>
                        <Box sx={{ pt: 1, pl: 2 }}>
                            {/* サブセクション2 */}
                            <ExpandableHeader
                                label="避難指示発令地域"
                                expanded={evacAreaOpen}
                                toggle={() => setEvacAreaOpen(!evacAreaOpen)}
                                sx={{ mb: 0.25 }}
                            />
                            <Collapse in={evacAreaOpen}>
                                <Stack direction="column" spacing={0.5} pl={1}>
                                    {evacAreaItems.map((item, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Circle sx={{ color: item.color, fontSize: "10px" }} />
                                            <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 70 }}>{item.label}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Collapse>
                        </Box>
                    </Collapse>
                </Box>
            </Popover>
        </>
    );
};
export default MapShelterAnalysisLegendIcon;